module.exports = __webpack_public_path__ + "img/SOUTH_BOHEMIA.714b612b.jpg";